import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Col, Label, Row, TextArea } from '@folio/stripes-components';

import { useIntl } from 'react-intl';
import { required } from '../../../utils/utils';
import HelpeModal from '../../HelpeModal';
import css from '../styles.css';

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  fieldName: PropTypes.string,
  parentField: PropTypes.object,
  showHelpeIcon: PropTypes.bool,
};

function TextAreaFieldComponent({
  fieldValues,
  index,
  fieldName,
  parentField,
  showHelpeIcon,
}) {
  const { locale } = useIntl();
  const { name, label, type, isRequired, canEdit, isRepeatable, helpeText } =
    fieldValues;

  const fieldLabel = label.find((field) => field.locale === locale)?.value;

  const helpeCondition =
    showHelpeIcon &&
    parentField?.type !== 'fieldArray' &&
    !isRepeatable &&
    helpeText;
  const containerCondition =
    parentField?.type !== 'fieldArray' && !isRepeatable;

  const handleFieldLabelAppeerance = () => {
    if (isRepeatable || (parentField?.type === 'fieldArray' && index !== 0)) {
      return null;
    }

    return <Label fullWidth>{fieldLabel}</Label>;
  };

  return (
    <Row className={containerCondition ? css.container : ''}>
      <Col xs={helpeCondition ? 11 : 12}>
        <Field
          id={`inventory-templates-form-generator-${type}-field-${index}`}
          component={TextArea}
          subscription={{ value: true }}
          fullWidth
          name={fieldName}
          label={handleFieldLabelAppeerance()}
          required={isRequired}
          validate={isRequired ? required : undefined}
          type="text"
          rows={1}
          disabled={!canEdit}
          parse={(value) => (value === '' ? null : value)} // Fix issue: Empty values don't appear in values
        />
      </Col>
      {helpeCondition && (
        <Col xs={1} className={css.margin_btn}>
          <HelpeModal
            fieldData={fieldValues}
            title={fieldLabel}
            iconSize="medium"
          />
        </Col>
      )}
    </Row>
  );
}

TextAreaFieldComponent.propTypes = propTypes;

export default TextAreaFieldComponent;
